import * as serializers from '../../serializers'

export const common = serializers.application

export const itemSerialize = (item) => {
  return {
    ...item
  }
}

export const timelineList = (data) =>
  data.map((item) => ({
    id: item.id,
    date: item.date,
    events: item.events.map(itemSerialize)
  }))

export const timelinePagination = (metadata) => metadata.pagination
